import { useCallback, useEffect, useState } from "react";
import { Loader2, MessageSquareText, Star, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { API, useShop } from "@/context/ShopContext";

export const AdminReviews = () => {
  const { byId } = useShop();
  const [reviews, setReviews] = useState(null);

  const load = useCallback(() => {
    fetch(`${API}/admin/reviews`, { credentials: "include" })
      .then((r) => r.json())
      .then((d) => setReviews(d.reviews || []))
      .catch(() => {});
  }, []);

  useEffect(() => { load(); }, [load]);

  const del = async (id) => {
    if (!window.confirm("Delete this review permanently?")) return;
    const r = await fetch(`${API}/admin/reviews/${id}`, { method: "DELETE", credentials: "include" });
    if (r.ok) {
      toast.success("Review deleted");
      load();
    } else {
      toast.error("Could not delete review");
    }
  };

  if (reviews === null) {
    return <div className="py-24 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-taupe" /></div>;
  }

  if (reviews.length === 0) {
    return (
      <div className="py-20 text-center" data-testid="reviews-empty">
        <MessageSquareText className="w-8 h-8 text-taupe mx-auto" strokeWidth={1} />
        <p className="font-serif text-xl mt-4">No reviews yet</p>
        <p className="text-sm text-taupe mt-2">Customer reviews will appear here once buyers start sharing.</p>
      </div>
    );
  }

  return (
    <div className="mt-10 space-y-4 max-w-3xl" data-testid="admin-reviews">
      {reviews.map((r) => {
        const p = byId[r.product_id];
        return (
          <div key={r.id} className="bg-white border border-beige px-6 py-5" data-testid={`admin-review-${r.id}`}>
            <div className="flex flex-wrap items-center gap-3">
              <span className="inline-flex gap-0.5">
                {[1, 2, 3, 4, 5].map((n) => (
                  <Star key={n} className={`w-3.5 h-3.5 ${n <= r.rating ? "fill-rose text-rose" : "text-beige"}`} strokeWidth={1.5} />
                ))}
              </span>
              <p className="text-sm font-medium">{r.name}</p>
              <p className="text-xs text-taupe">
                on {p ? `${p.shade}${p.fabric ? ` — ${p.fabric}` : ""}` : r.product_id} · {new Date(r.created_at).toLocaleDateString("en-IN", { dateStyle: "medium" })}
              </p>
              <button
                onClick={() => del(r.id)}
                data-testid={`admin-review-delete-${r.id}`}
                aria-label="Delete review"
                className="ml-auto p-2 text-taupe hover:text-rose transition-colors"
              >
                <Trash2 className="w-4 h-4" strokeWidth={1.5} />
              </button>
            </div>
            {r.text && <p className="text-sm text-espresso/75 leading-relaxed mt-2">{r.text}</p>}
          </div>
        );
      })}
    </div>
  );
};
